import React from 'react';
import PrayerButtonGrid from '../components/PrayerButtonGrid';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const categories = [
  'daily',
  'christian',
  'catholic',
  'father',
  'mother',
  'wife_prayer',
  'husband_prayer',
  'son_prayer',
  'daughter_prayer',
  'brother_prayer',
  'sister_prayer',
  'friend_prayer',
  'health_prayer',
  'finances_prayer',
  'world_prayer',
  'extended_family_prayer'
];

const labels = {
  daily: 'Ежедневная',
  christian: 'Христианские',
  catholic: 'Католические',
  father: 'папа',
  mother: 'мама',
  wife_prayer: 'Жена',
  husband_prayer: 'Муж',
  son_prayer: 'Сын',
  daughter_prayer: 'Дочь',
  brother_prayer: 'Брат',
  sister_prayer: 'Сестра',
  friend_prayer: 'Друг',
  health_prayer: 'Здоровье',
  finances_prayer: 'Финансы',
  world_prayer: 'Мир',
  extended_family_prayer: 'Расширенная семья'
};

function RussianHomePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Выберите молитву</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) => navigate(`/ru/prayer/${cat}`, { state: { from: '/ru' } })}
      />

      {/* ➕ More Prayers Button */}
      <div className="text-center mt-3">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate('/ru/more')}>
          Дополнительные молитвы
        </Button>
      </div>

    </Container>
  );
}

export default RussianHomePage;
